export const environments = {
  Development: {
    googleAnalytics: {
      p2: "G-V13HJP5DH2",
      p3: "G-LVB11HS1NE"
    }
  },
  DevAzure: {
    cookieScriptUrl:
      "//profiling1.avandor.com/consent3/cmp.js?LCxDQFcrVllOKzctVCtHKU8KYAo=",
    googleAnalytics: {
      p2: "G-V13HJP5DH2",
      p3: "G-LVB11HS1NE"
    }
  },
  Staging: {
    cookieScriptUrl:
      "//profiling1.avandor.com/consent3/cmp.js?LSxDQFcrVllOKzc1QT0iWVI7UGBgCmAK",
    googleAnalytics: {
      p2: "G-1EPYEVE5D6",
      p3: "G-4P356HRJ7H"
    }
  },
  Production: {
    cookieScriptUrl:
      "//profiling1.avandor.com/consent3/cmp.js?KSxDQFcrVllOK0cpTwpgCg==",
    googleAnalytics: {
      p2: "G-XMBEMS0HQD",
      p3: "G-HX0HDDRS0M"
    }
  }
};
